import { Outlet } from "react-router-dom";
import { sidebarListBuyer } from "../../constants/sidebarList";
import { ProtectedRoute } from "../../middleware/ProtectedRoute";
import { ContentDashboardContainer } from "../container/ContentDashboardContainer";
import { DashboardContainer } from "../container/DashboardContainer";

export const LayoutDashboardBuyer = () => {
  return (
    <ProtectedRoute userType="buyer">
      <DashboardContainer data={sidebarListBuyer} pageRoot="/buyer">
        <ContentDashboardContainer>
          <Outlet />
        </ContentDashboardContainer>
      </DashboardContainer>
    </ProtectedRoute>
  );
};
